import axios from 'axios'

const axiosApi = axios.create({

});


// Set the initial header from storage or something (should surround with try catch in actual app)



export default axiosApi;